import { BrokerageTabs } from './brokerage-tabs';

export const BrokerageContainer = () => {
  return (
    <>
      <BrokerageTabs />
    </>
  );
};
